<template>
	<div class="tab-con">
		<div class="x-white"></div>
		<ul class="tab-menu">
			<li class="x-flow" @click.capture="switchScope(1,$event)">
				<div class="tab-item">
					<i class="x-inline" :class="[decideActive('t',1,1)]"></i>
					<span class="x-inline" :class="[decideActive('b',1)]">
						{{ whichLang($path) ? 'Social Recruitment' : 'Social Recruitment' }}
					</span>
				</div>
			</li>
			<li class="x-flow" @click.capture="switchScope(2,$event)">
				<div class="tab-item">
					<i class="x-inline" :class="[decideActive('t',2,2)]"></i>
					<span class="x-inline" :class="[decideActive('b',2)]">
						{{ whichLang($path) ? 'Campus Recruitment' : 'Campus Recruitment' }}
					</span>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>

    export default {
        props: {
            activeScope: {
                type: Number
            },
            activeName: {
                type: Number
            }
        },
        methods: {
            switchScope: function (scope, event) {
                const _this = this;
                if (_this.activeName == 1) {
                    _this.$emit('do', {type: 'scope', val: scope});
                } else {
                    _this.$emit('find', {activeName: 1, activeScope: scope});
                }
                _this.$emit('height', {
                    type: 'screen', val: {
                        posListheight: '88.5625rem',
                        posConheight: '84.0625rem',
                        listConheight: '74rem',
                    }
                })
            },
            whichLang: function (path) {
                return path == 'zh-cn';
            },
            decideActive: function (decideType, originScope, itemOn = 1) {
                const _this = this;
                const activeScope = _this.activeScope;
                if (decideType == 't') {
                    if (itemOn == 1) {
                        if (activeScope == originScope) {
                            return 'x-icon-house-active';
                        } else {
                            return 'x-icon-house';
                        }
                    } else {
                        if (activeScope == originScope) {
                            return 'x-icon-hat-active';
                        } else {
                            return 'x-icon-hat'
                        }
                    }
                } else {
                    if (activeScope == originScope) {
                        return 'tab-active';
                    } else {
                        return '';
                    }
                }
            }
        },
        watch: {
            activeScope: function (scope) {
                const _this = this;
            }
        },
        mounted(){
            const _this = this;
            //console.log("Template[tab]", _this.activeScope)
        },
        computed: {}
    }

</script>

<style scoped>
	.tab-con > .x-white {
		height: 4.625rem;
		border: none;
	}

	.tab-con > .tab-menu {
		height: 5.0625rem;
		width: 64rem;
		/*max-width: 1024px;*/
		margin: 0 auto;
	}

	.tab-menu > li {
		width: 32rem;
		min-width: 32rem;
		height: 100%;
	}

	.tab-item {
		height: 100%;
		width: 80%;
		margin: 0 auto;
		text-align: center;
		line-height: 100%;
		border: none;
		cursor: pointer;
	}

	.tab-item > span {
		font-family: Open SEI;
		font-size: 2rem;
		color: #2A2E2E;
		line-height: 4.625rem;
		height: 4.625rem;
	}

	.tab-active {
		border-bottom: .375rem solid #F5A623;
	}

	.x-icon-house-active {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_recruit_sociology_nor.png");
		width: 3.5rem;
		height: 3.5rem;
		position: relative;
		top: .75rem;
	}

	.x-icon-house {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_recruit_sociology_grey.png");
		width: 3.5rem;
		height: 3.5rem;
		position: relative;
		top: .75rem;
	}

	.x-icon-hat-active {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_recruit_school_nor.png");
		width: 3.5rem;
		height: 3.5rem;
		position: relative;
		top: .75rem;
	}

	.x-icon-hat {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_recruit_school_grey.png");
		width: 3.5rem;
		height: 3.5rem;
		position: relative;
		top: .75rem;
	}

</style>


// WEBPACK FOOTER //
// src/components/zh-cn/join/join-tab.vue